/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-interface, @typescript-eslint/naming-convention */
/**
 * ИС "Продовольствие"
 * Целями создания ИС «Учет идентификационных карт» являются упрощение и ускорение выдачи идентификационных карт
      и продовольствия по ним гражданам Ростовской области в период введения особого положения в регионе, а также учет
      выданных карт и продовольствия по ним для оперативного формирования плана обеспечения региона.
 *
 * OpenAPI spec version: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator+.
 * https://github.com/karlvr/openapi-generator-plus
 * Do not edit the class manually.
 */

import { Context } from "../../common";
import { Configuration } from "./configuration";

export const BASE_PATH = "http://localhost:3000".replace(/\/+$/, "");

export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'

export type HttpRequestHeaders = Record<string, string | undefined>

export interface HttpRequestOptions {
	method: HttpMethod
	headers?: HttpRequestHeaders
	body?: unknown
}

export type HttpRequestOptionsInit = Partial<HttpRequestOptions>

export interface HttpRequest {
  url: string
	options: HttpRequestOptions
}

export interface HttpResponseHeaders {
  get(name: string): string | undefined
}

export interface HttpResponse {
  status: number
  headers: HttpResponseHeaders
	json(): Promise<unknown>
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isHttpResponse(o: any): o is HttpResponse {
  if (typeof o !== 'object' || o === undefined || o === null) return false
  return o.status && o.headers && o.json
}

export interface HttpClient {
  exec(ctx: Context, url: string, options: HttpRequestOptions): Promise<HttpResponse>
}

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
	csv: ",",
	ssv: " ",
	tsv: "\t",
	pipes: "|",
};



/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
	protected configuration?: Configuration;

	constructor(protected client: HttpClient, configuration?: Configuration, protected basePath: string = BASE_PATH) {
		if (configuration) {
			this.configuration = configuration;
			this.basePath = configuration.basePath ?? this.basePath;
		}
	}
};

export class ApiClientError extends Error {
}


/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends ApiClientError {
	constructor(public field: string, msg?: string) {
		super(msg);
		Object.setPrototypeOf(this, RequiredError.prototype);
		this.name = "RequiredError";
	}
}
